import { isProduction } from "authConfig";
import { IOpenApiService } from "services/models/ApiService";
import { TaskStatus } from "services/models/TaskStatus";
import { smFetch } from "./misc";

export class OpenApiService implements IOpenApiService {
  static openUrl = isProduction
    ? "https://softwareservices.sanmanuel.com"
    : "https://softwareservicesstaging.sanmanuel.com";
  getTaskStatus(path: string): Promise<Response> {
    return smFetch(`${OpenApiService.openUrl}${path}`, { redirect: "manual" });
  }
}
